<template>
  <v-menu v-model="dropdownIsOpen" :close-on-content-click="false" location="start center">
    <template #activator="{ props }">
      <v-btn-icon :disabled="disabled" class="tour-navigate-timeline" size="small" v-bind="props">
        <v-icon size="large">far fa-search</v-icon>
        <v-tooltip :disabled="dropdownIsOpen" location="bottom" activator="parent">{{ $t('NAV.SEARCH_ON_PLANNING') }}</v-tooltip>
      </v-btn-icon>
    </template>
    <v-list class="pt-4 pb-8">
      <v-list-item>
        <div class="mb-1"><b>{{ $t('NAV.NAVIGATE_TIMELINE') }}</b></div>
        <v-select v-model="selectedCol" :items="visibleTimelineCols" :item-title="(col) => col.label"
                  :placeholder="$t('NAV.GO_TO_DATE')" :menu-props="{ location: 'bottom' }" return-object density="compact"
                  @update:model-value="gotoDate()">
        </v-select>
      </v-list-item>
      <v-list-item class="mt-4">
        <div class="mb-1"><b>{{ $t('NAV.LOOK_FOR_BUBBLE') }}</b></div>
        <select-element v-model="selectedElement" :items="planning.elements" :placeholder="`${$t('GLOBAL.SEARCH')}...`" density="compact" autofocus
                        @update:model-value="openSelectedElement()">
        </select-element>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  import SelectElement from '@/components/Reusables/SelectElement.vue';

  export default {
    components: {
      SelectElement,
    },
    props: {
      planning: { type: Object, required: true },
      disabled: { type: Boolean, default: false },
    },
    emits: ['open-element'],
    data() {
      return {
        selectedCol: null,
        selectedElement: null,
        dropdownIsOpen: null,
      };
    },
    computed: {
      visibleTimelineCols() {
        return this.planning.visibleTimeline && this.planning.visibleTimeline.timelinecols || null;
      },
    },
    methods: {
      gotoDate() {
        const col = this.selectedCol;
        const { visibleTimeline } = this.planning;
        if (! col || ! visibleTimeline) return;
        const duration = moment(col.starttime).diffWithWorkdays(visibleTimeline.starttime, 'minutes', visibleTimeline.workdays);
        $("#table-wrapper").scrollLeft(duration / visibleTimeline.minuteperpx - 200);
        this.dropdownIsOpen = false;
        this.$nextTick(() => {
          this.selectedCol = null;
        });
      },
      openSelectedElement() {
        this.$emit('open-element', this.selectedElement);
        this.dropdownIsOpen = false;
        this.$nextTick(() => {
          this.selectedElement = null;
        });
      },
      defaultTitle(el) {
        return this.$t('helpers.elDefaultTitle', { type: el.getType() });
      },
    },
  };
</script>
